import React from 'react';
import { KPICard } from '@/components/ui';
import { formatCurrency } from '@/utils/format';

interface BoqKPISectionProps {
  stats: {
    totalValue: number;
    totalCount: number;
    materialShare: number;
    laborShare: number;
    equipmentShare: number;
  };
  variant?: 'default' | 'detail';
}

export function BoqKPISection({ stats, variant = 'default' }: BoqKPISectionProps) {
  if (variant === 'detail') {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <KPICard 
          title="Tổng giá trị" 
          value={formatCurrency(stats.totalValue)} 
          icon="ri-money-dollar-circle-line" 
          variant="primary" 
        />
        <KPICard 
          title="Vật tư" 
          value={`${stats.materialShare}%`} 
          icon="ri-hammer-line" 
          variant="info" 
        />
        <KPICard 
          title="Nhân công" 
          value={`${stats.laborShare}%`} 
          icon="ri-team-line" 
          variant="warning" 
        />
        <KPICard title="Thiết bị" value={stats.equipmentShare} format="percentage" variant="primary" icon="ri-truck-line" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <KPICard 
        title="Tổng giá trị BOQ" 
        value={formatCurrency(stats.totalValue)} 
        icon="ri-calculator-line" 
        variant="primary" 
      />
      <KPICard 
        title="Số lượng hạng mục" 
        value={stats.totalCount} 
        icon="ri-list-check-3" 
        variant="info" 
      />
      <KPICard 
        title="Tỷ lệ hoàn thành" 
        value="0%" 
        icon="ri-line-chart-line" 
        variant="success" 
      />
    </div>
  );
}
